import Vue from "vue";
import {
    Button,
    Cell,
    CellGroup,
    Icon,
    Image as VanImage,
    Col,
    Row,
    Popup,
    Toast,
    Calendar,
    Checkbox,
    CheckboxGroup,
    DatetimePicker,
    Field,
    Form,
    NumberKeyboard,
    PasswordInput,
    RadioGroup,
    Radio,
    Search,
    Switch,
    Sticky,
    Swipe,
    SwipeItem,
    Lazyload,
    PullRefresh,
    List,
    Dialog,
    Skeleton,
    Empty,
    Tabbar,
    TabbarItem,
    Grid,
    GridItem,
    Tab,
    Tabs,
    Tag,
    Divider,
    Picker,
    Uploader,
    ImagePreview,
    Loading,
    NavBar,
    IndexAnchor,
    ActionSheet,
    ContactEdit,
    IndexBar
} from "vant";

Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Search);
Vue.use(Calendar);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatetimePicker);
Vue.use(Field);
Vue.use(Form);
Vue.use(NumberKeyboard);
Vue.use(PasswordInput);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Sticky);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Dialog);
Vue.use(Skeleton);
Vue.use(Empty);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(Picker);
Vue.use(Uploader);
Vue.use(ImagePreview);
Vue.use(Loading);
Vue.use(NavBar);
Vue.use(IndexAnchor);
Vue.use(ActionSheet);
Vue.use(ContactEdit);
Vue.use(IndexBar);

Toast.setDefaultOptions({
    position: "bottom",
    className: "toast-custom"
});
